import React, { useState } from 'react';
import cn from 'classnames';
import StarRating from '~/components/ui/StarRating';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import PopupClose from '../Close';

export default function Feedback({courseData, onResultCallback}) {
  const [courseRate, setCourseRate] = useState(0);
  const [recomRate, setRecomRate] = useState(0);
  const [review, setReview] = useState('');
  const [spinner, setSpinnerState] = useState(spinnerStates.done);
  const [errorApiMessage, setErrorApiMessage] = useState("");
  const [errorStaticMessage, setErrorStaticMessage] = useState("");

  const courseRateNotFilled = !courseRate && errorStaticMessage;
  const recomRateNotFilled = !recomRate && errorStaticMessage;

  const onChangeCourseRate = (rValue) => {
    setCourseRate(rValue);
    if (!recomRateNotFilled) setErrorStaticMessage('');
  };
  const onChangeRecomRate = (rValue) => {
    setRecomRate(rValue);
    if (!courseRateNotFilled) setErrorStaticMessage('');
  };
  const onChangeReview = (e) => setReview(e.target.value);

  const onSendFeedback = () => {
    if (!courseRate || !recomRate) {
      setErrorStaticMessage("Пожалуйста, поставьте оценку чтобы продолжить");
    } else {
      const url = `${routes.user.review}/${courseData.rfId}`;
      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          COURSE_RATE: courseRate,
          RECOM_RATE: recomRate,
          REVIEW: review,
        }),
      };

      setErrorApiMessage("");
      setSpinnerState(spinnerStates.pending);

      fetch(url, options)
        .then(response => response.json())
        .then(json => {
          switch (json.status) {
            case 'success':
              onResultCallback();
              break;
            case 'error':
              setErrorApiMessage(json.errors[0].message);
              setSpinnerState(spinnerStates.done);
              break;
            default:
              setErrorApiMessage(messages.unknownError);
              setSpinnerState(spinnerStates.done);
          }
        })
        .catch(() => {
          setErrorApiMessage(messages.serverTimeout);
          setSpinnerState(spinnerStates.done);
        });
    }
  };

  return (
    <div className="popup feedback-popup">
      <div className="popup__close-container"><PopupClose/></div>
      <div className="feedback-popup__title">
        <div className="feedback-popup__title-small">Пожалуйста, оцените курс</div>
        <div className="feedback-popup__title-big">&quot;{courseData.header}&quot;</div>
      </div>
      <div className="feedback-popup__line" />
      <div className={
        cn("feedback-popup__field-title", {"feedback-popup__field-title--warning": courseRateNotFilled})
      }>
        Общее впечатление от курса
      </div>
      <StarRating className="feedback-popup__field-stars-rating" onResult={onChangeCourseRate} name="courseRate" />
      <div className="feedback-popup__line" />
      <div className={
        cn("feedback-popup__field-title", {"feedback-popup__field-title--warning": recomRateNotFilled})
      }>
        С какой вероятностью вы порекомендуете курс своим друзьям и знакомым
      </div>
      <StarRating className="feedback-popup__field-stars-rating" onResult={onChangeRecomRate} name="recomRate" />
      <div className="feedback-popup__line" />
      <div className="feedback-popup__field-title">Дополнительная информация и комментарии:</div>
      <textarea className="feedback-popup__field-textarea" placeholder="Введите текст" value={review} onChange={onChangeReview} rows="5" />
      <div className="feedback-popup__wrapper-btn">
        <button type="button" className="btn btn--primary feedback-popup__btn" onClick={onSendFeedback}>
          {spinner === spinnerStates.done ? (
            "Оставить\u00A0отзыв"
          ) : (
            <>
              <span className="invisible">Оставить{'\u00A0'}отзыв</span>
              <Loader
                spinnerState={spinner}
                spinnerPosition={spinnerPositions.absolute}
                className="loader--white"
              />
            </>
          )}
        </button>
        {(errorStaticMessage || errorApiMessage) && <div className="feedback-popup__text-error">{errorStaticMessage || errorApiMessage}</div>}
      </div>
    </div>
  );
}